"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelect = exports.typedMemo = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var Autocomplete_1 = __importDefault(require("@material-ui/lab/Autocomplete"));
var Popper_1 = __importDefault(require("@material-ui/core/Popper"));
var icons_1 = require("@material-ui/icons");
var Checkbox_1 = require("../../atoms/Checkbox");
var TextField_1 = require("../../atoms/TextField");
var styles_1 = __importDefault(require("./styles"));
exports.typedMemo = react_1.default.memo;
// TODO: TOUCH AND DIE BY STEPHENS HANDS
// depreciated
exports.MultiSelect = (0, exports.typedMemo)(function (_a) {
    var options = _a.options, label = _a.label, onChange = _a.onChange, disabled = _a.disabled, _b = _a.limitTags, limitTags = _b === void 0 ? 3 : _b, _c = _a.canAddOptions, canAddOptions = _c === void 0 ? false : _c, _d = _a.loading, loading = _d === void 0 ? false : _d, setUniversalOptions = _a.setUniversalOptions, autocompleteProps = _a.autocompleteProps, _e = _a.disablePortal, disablePortal = _e === void 0 ? false : _e, positionStatic = _a.positionStatic, _f = _a.customPopperStyles, customPopperStyles = _f === void 0 ? undefined : _f, rest = __rest(_a, ["options", "label", "onChange", "disabled", "limitTags", "canAddOptions", "loading", "setUniversalOptions", "autocompleteProps", "disablePortal", "positionStatic", "customPopperStyles"]);
    var _g = (0, react_1.useState)(false), open = _g[0], setOpen = _g[1];
    var classes = (0, styles_1.default)({ open: open, positionStatic: positionStatic });
    var _h = (0, react_1.useState)(options), extendedOptions = _h[0], setExtendedOptions = _h[1];
    (0, react_1.useEffect)(function () {
        setExtendedOptions(options);
    }, [options]);
    var removeFormat = function (value) { return value.trim().toLowerCase(); };
    var onEnterPress = function (e) {
        if (canAddOptions && e.key === "Enter") {
            var newTag_1 = e.target.value;
            if (newTag_1 &&
                !setUniversalOptions &&
                !extendedOptions.some(function (option) { return removeFormat(option.text) === removeFormat(newTag_1); })) {
                setExtendedOptions(function (prev) { return __spreadArray([
                    { value: newTag_1, text: newTag_1 }
                ], prev, true); });
            }
            else if (newTag_1 &&
                setUniversalOptions &&
                !options.some(function (option) { return removeFormat(option.text) === removeFormat(newTag_1); })) {
                setUniversalOptions(function (prev) { return __spreadArray([newTag_1], prev, true); });
            }
        }
    };
    var PopperMy = (0, react_1.useCallback)(function (props) { return ((0, jsx_runtime_1.jsx)(Popper_1.default, __assign({}, props, { style: customPopperStyles
            ? __assign({}, customPopperStyles) : {
            width: "99%",
            overflow: "auto",
        }, placement: "bottom-start" }))); }, [customPopperStyles]);
    return ((0, jsx_runtime_1.jsx)(Autocomplete_1.default, __assign({ PopperComponent: PopperMy, onChange: function (_, newValue) {
            return onChange(newValue);
        }, multiple: true, disabled: disabled || loading, openOnFocus: true, options: canAddOptions && !setUniversalOptions ? extendedOptions : options, limitTags: limitTags, fullWidth: true, disablePortal: disablePortal, disableCloseOnSelect: true, classes: { root: classes.autocomplete }, popupIcon: loading ? (0, jsx_runtime_1.jsx)(icons_1.Autorenew, {}) : (0, jsx_runtime_1.jsx)(icons_1.ArrowDropDown, {}), ListboxProps: {
            className: classes.list,
        }, ChipProps: {
            classes: { root: classes.chips },
            deleteIcon: ((0, jsx_runtime_1.jsx)(icons_1.ClearRounded, { "data-testid": "delete-chip-icon", color: "inherit", height: "12", width: "12" })),
        }, getOptionLabel: function (option) { return option.text; }, renderOption: function (option, _a) {
            var selected = _a.selected;
            return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.menuItem }, { children: [(0, jsx_runtime_1.jsx)(Checkbox_1.Checkbox, { id: "".concat(option.text, "MultiSelectCheckbox"), checked: selected, labelStyles: { margin: "0 0 0 -10px" } }), option.text] })));
        }, renderInput: function (params) { return ((0, jsx_runtime_1.jsx)(TextField_1.TextField, __assign({}, params, rest, { label: label, onKeyDown: onEnterPress }))); }, defaultValue: rest.defaultValue, getOptionSelected: function (opt, value) { return opt.text === value.text; }, getOptionDisabled: function (option) { return option.disabled || false; }, onOpen: function () { return setOpen(true); }, onClose: function () { return setOpen(false); } }, autocompleteProps)));
});
